import { useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Settings,
  Heart,
  PackageSearch,
  LogOut,
  ShoppingCart,
  PanelLeft,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";


const DashboardLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const menuItems = [
    { label: "Dashboard", icon: <LayoutDashboard size={18} />, path: "/dashboard" },
    { label: "Cart", icon: <ShoppingCart size={18} />, path: "/dashboard/cart" },
    { label: "My Orders", icon: <PackageSearch size={18} />, path: "/dashboard/orders" },
    { label: "Wishlist", icon: <Heart size={18} />, path: "/dashboard/wishlist" },
    { label: "Account Settings", icon: <Settings size={18} />, path: "/dashboard/settings" },
  ];

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-blue-50">
      {/* Sidebar */}
      <aside className="lg:w-1/5 bg-white border-r lg:min-h-screen shadow-sm">
        {/* Mobile Header */}
        <div className="flex items-center justify-between p-4 lg:hidden border-b">
          <h1 className="text-lg font-semibold">Dashboard</h1>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-700 focus:outline-none"
          >
            <PanelLeft />
          </button>
        </div>

        {/* Sidebar Menu */}
        <nav
          className={`${
            menuOpen ? "block" : "hidden"
          } lg:block px-4 py-6 space-y-2 transition-all`}
        >
          {menuItems.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium ${
                location.pathname === item.path
                  ? "bg-blue-100 text-blue-700"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
            >
              {item.icon}
              {item.label}
            </Link>
          ))}

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 text-sm font-medium"
          >
            <LogOut size={18} />
            Logout
          </button>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
